import { Popover, PopoverContent, FlexBox, Box, Typography, PopoverCloser, Button, PopoverLauncher } from '@vp/swan';
import React from 'react';
import dt from './node_modules-styled-components-dist-styled-components.browser.esm.js';
import { useScopedBaseConfig } from './src-contexts-CouponCalloutConfig.context.js';
import { useLocalization } from './src-hooks-useLocalizations.js';
import { useCouponDetailsStore } from './src-store-couponDetails.store.js';
import { ClickableStyledIcon } from './src-styledComponents-couponComponent.styles.js';

const StyledPopoverLauncher = dt(PopoverLauncher)`
  display: flex !important;
  align-items: center;
`;
const CouponCodePopover = ({ queryKey, children }) => {
  const { t } = useLocalization();
  const { locale, pageId } = useScopedBaseConfig();
  const productCouponDetails = useCouponDetailsStore((state) => state.data[pageId]?.couponDetails?.productCouponData?.[queryKey]);
  if (!locale || !productCouponDetails) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Popover, { "aria-label": t("coupon-callout.promo-code") }, /* @__PURE__ */ React.createElement(StyledPopoverLauncher, null, children), /* @__PURE__ */ React.createElement(PopoverContent, { "aria-label": t("coupon-callout.coupon-callout-popover"), dialog: true }, /* @__PURE__ */ React.createElement(FlexBox, { gap: "5" }, /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Typography, { fontWeight: "bold", fontSize: "small" }, productCouponDetails.messaging.displayMessage, "\xA0"), /* @__PURE__ */ React.createElement(Typography, { fontSize: "small" }, productCouponDetails.messaging.staticLegalCopy), /* @__PURE__ */ React.createElement(Typography, { fontSkin: "footnote", textColor: "subtle" }, productCouponDetails.expiresAt && t("coupon-callout.coupon-expiry-message", {
    Date: new Intl.DateTimeFormat(locale, {
      month: "long",
      day: "numeric",
      year: "numeric"
    }).format(new Date(productCouponDetails.expiresAt))
  }))), /* @__PURE__ */ React.createElement(PopoverCloser, null, /* @__PURE__ */ React.createElement(Button, { skin: "unstyled" }, /* @__PURE__ */ React.createElement(ClickableStyledIcon, { iconType: "close", alt: t("coupon-callout.cancel-icon") }))))));
};

export { CouponCodePopover };
//# sourceMappingURL=src-components-CouponDisplay-CouponCodePopover.js.map
